import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

const QUICK = ["Bullying ou ofensa", "Conteúdo impróprio", "Pedido de contato pessoal", "Comportamento suspeito", "Me sinto inseguro(a)"];

export function ReportDialog({ open, onOpenChange, target, panic, onSubmit }) {
  const [reason, setReason] = useState("");
  const send = () => {
    onSubmit(reason || QUICK[panic ? 4 : 0]);
    setReason("");
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid={panic ? "panic-dialog" : "report-dialog"}>
        <DialogHeader>
          <DialogTitle className={panic ? "text-red-400" : ""}>{panic ? "Botão de pânico" : `Denunciar ${target?.user_name || ""}`}</DialogTitle>
          <DialogDescription>
            {panic ? "Os moderadores humanos da instituição serão alertados imediatamente e você sairá da sala com segurança." : "Sua denúncia é anônima para o denunciado e vai direto aos moderadores."}
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-2">
          {QUICK.map((q) => (
            <button key={q} onClick={() => setReason(q)} className={`rounded-full px-3 py-1.5 text-xs font-semibold ${reason === q ? "bg-[hsl(var(--gold))] text-[#0B0F17]" : "bg-white/5 hover:bg-white/10"}`} data-testid={`report-quick-${q.split(" ")[0].toLowerCase()}`}>
              {q}
            </button>
          ))}
        </div>
        <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Descreva rapidamente (opcional)" data-testid="report-reason-input" />
        <Button onClick={send} className={`w-full rounded-full ${panic ? "bg-red-600 hover:bg-red-500" : ""}`} data-testid="report-submit-button">
          {panic ? "Alertar moderadores e sair" : "Enviar denúncia"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
